// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);



  // Decode token to get user info
  useEffect(() => {
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUser(decoded);
      } catch (err) {
        console.error('Invalid token');
        logout();
      }
    }
    setLoading(false);
  }, [token]);

  const login = (data) => {
    // 1. Persist both tokens to LocalStorage immediately
    localStorage.setItem('token', data.accessToken);
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }

    // 2. Update state for immediate UI reaction
    setToken(data.accessToken);

    // 3. Decode user info from the Access Token
    try {
      const decoded = JSON.parse(atob(data.accessToken.split('.')[1]));
      setUser(decoded);
    } catch (err) {
      console.error('Failed to decode user on login', err);
    }
  };
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    setToken('');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
